<template>
  <v-content v-if="quote && copy">
    <Header title="Instruction confirmation form" />
    <v-container>
      <v-card>
        <v-card-text>
          <!-- <div>{{ quote.quotetype.id }}</div> -->
          <h1>{{ quote.quotetype.name }}</h1>
          <div>
            Quote id: {{ quote.id }} &#160;
            <span v-if="saving" style="background: red; color: white"
              >Saving...</span
            >
          </div>
          <p style="font-size: 1.4em; margin-top: 10px">
            Please fill in the sections below to help us get your file set up.
            If you are unsure about anything or need more help do not hesitate
            to email us at
            <a href="mailto:sales@nbmlaw.co.uk">sales@nbmlaw.co.uk</a> or call
            us on
            <a href="tel:+441245357348">
              <span style="font-weight: bold">01245 357348</span>
            </a>
          </p>
        </v-card-text>
      </v-card>
      <br />
      <v-card>
        <v-card-text>
          <h3>Individuals involved in the transaction</h3>
          <v-alert :value="true" type="info" outline>
            Please add a record for each individual who will be involved in the
            transaction
          </v-alert>
          <v-btn @click="navigateIndividual(null)" color="info" small
            ><v-icon>add</v-icon> individual</v-btn
          >
          <div>{{ computedIndividualsCount }}</div>
          <div v-if="individualsCount > 0">
            <div
              v-for="(individual, individualId) in quote.individuals"
              :key="individualId"
              :class="classIndividual(individualId)"
            >
              <div>Title: {{ individual.title }}</div>
              <div>Forename: {{ individual.forename }}</div>
              <div>Surname: {{ individual.surname }}</div>
              <div>Dob: {{ individual.dob }}</div>
              <div v-if="individual.email">Email: {{ individual.email }}</div>
              <div v-if="individual.mobile">
                Mobile: {{ individual.mobile }}
              </div>
              <div v-if="individual.address">
                Address: {{ individual.address }}
              </div>
              <div>
                <v-btn
                  @click="navigateIndividual(individualId)"
                  color="info"
                  small
                  ><v-icon>edit</v-icon>
                  Edit
                </v-btn>
                <v-btn
                  @click="deleteIndividual(individualId)"
                  color="error"
                  small
                  ><v-icon>delete</v-icon> Delete</v-btn
                >
              </div>
            </div>
          </div>
          <div style="color: red" v-if="errorIndividuals">
            {{ errorIndividuals }}
          </div>
        </v-card-text>
      </v-card>
      <br />
      <v-card>
        <v-card-text>
          <h3>Company</h3>
          <v-alert :value="true" type="info" outline>
            If the transaction is being executed through a company please add it
            below
          </v-alert>
          <v-btn
            @click="navigateCompany"
            color="info"
            small
            :disabled="quote.company != undefined"
            ><v-icon>add</v-icon> company</v-btn
          >
          <div v-if="computedCompanyStatus">
            {{ computedCompanyStatus }}
          </div>
          <div v-if="quote.company != undefined" class="rowNormal rowHighlight">
            <div>Name: {{ quote.company.name }}</div>
            <div v-if="quote.company.email">
              Email: {{ quote.company.email }}
            </div>
            <div v-if="quote.company.address">
              Address: {{ quote.company.address }}
            </div>
            <div>
              <v-btn @click="navigateCompany" color="info" small
                ><v-icon>edit</v-icon>
                Edit
              </v-btn>
              <v-btn @click="deleteCompany" color="error" small
                ><v-icon>delete</v-icon> Delete</v-btn
              >
            </div>
          </div>
        </v-card-text>
      </v-card>
      <br />
      <v-card>
        <v-card-text>
          <h3>General information</h3>
          <v-form
            ref="formInstructionConfirmation"
            v-model="valid"
            lazy-validation
          >
            <v-textarea
              v-model="copy.saleproperty"
              label="Address of the property you are selling (including postcode)"
              outline
              v-if="copy.saleproperty != undefined"
              :rules="valueRules"
              @input="updateDebounce"
            />
            <v-textarea
              v-model="copy.purchaseproperty"
              label="Address of the property you are purchasing (including postcode)"
              outline
              v-if="copy.purchaseproperty != undefined"
              @input="updateDebounce"
            />
            <v-textarea
              v-model="copy.mortgageproperty"
              label="Address of property to be remortgaged (including postcode)"
              outline
              v-if="copy.mortgageproperty != undefined"
              :rules="valueRules"
              @input="updateDebounce"
            />
            <v-textarea
              v-model="copy.transferproperty"
              label="Address of the subject property concerned with the transfer of equity (including postcode)"
              outline
              v-if="copy.transferproperty != undefined"
              :rules="valueRules"
              @input="updateDebounce"
            />
            <v-text-field
              v-model="copy.lenderexisting"
              label="Name of existing Lender/Mortgagee"
              v-if="copy.lenderexisting != undefined"
              outline
              :rules="valueRules"
              @input="updateDebounce"
            />
            <v-text-field
              v-model="copy.lendernew"
              label="Name of New Lender/Mortgagee"
              v-if="copy.lendernew != undefined"
              outline
              :rules="valueRules"
              @input="updateDebounce"
            />
            <v-textarea
              v-model="copy.mortgageexisting"
              label="Details of any existing mortgage on the subject property, if any: name of lender and mortgage amount"
              v-if="copy.mortgageexisting != undefined"
              outline
              @input="updateDebounce"
            />
            <v-textarea
              v-model="copy.description"
              label="A brief description of what you would like us to do"
              outline
              v-if="copy.description != undefined"
              @input="updateDebounce"
            />
            <div>
              <v-btn
                @click="submitInstructionConfirmation"
                color="success"
                :disabled="submitting"
                ><v-icon>thumb_up</v-icon>&#160;Submit</v-btn
              >
            </div>
            <div style="color: red" v-if="errorSubmit">
              {{ errorSubmit }}
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import Header from "@/components/Header";
import nbmlaw from "@/apis/nbmlaw";
export default {
  name: "InstructionConfirmation",
  components: { Header },
  computed: {
    computedIndividualsCount() {
      return this.individualsCount + " individual(s)";
    },
    computedCompanyStatus() {
      return this.quote && this.quote.company ? "" : "No company required";
    }
  },
  data() {
    return {
      quote: null,
      individualsCount: 0,
      copy: null,
      valid: false,
      valueRules: [(v) => !!v || "Value is required"],
      errorIndividuals: null,
      timerId: null,
      saving: false,
      submitting: false,
      errorSubmit: null
    };
  },
  methods: {
    async fetchQuote() {
      try {
        const response = await nbmlaw.get(
          `/cors/open/sales/quotes/${this.$route.params.quoteId}/instructionConfirmation`,
          {
            params: { salesUid: this.$route.params.salesUid }
          }
        );
        // console.log(response.data);
        this.quote = response.data;
      } catch (err) {
        console.log(err);
        this.$router.push({ name: "notfound" });
      }
    },
    navigateIndividual(individualId) {
      const path = {
        name: "individualAdd",
        params: {
          quoteId: this.$route.params.quoteId,
          salesUid: this.$route.params.salesUid
        }
      };
      if (individualId != undefined) {
        path.query = { individualId };
      }
      this.$router.push(path);
    },
    async deleteIndividual(individualId) {
      if (confirm("Are you sure?")) {
        await nbmlaw.delete(
          `/cors/open/sales/quotes/${this.$route.params.quoteId}/individuals/${individualId}`,
          {
            params: { salesUid: this.$route.params.salesUid }
          }
        );
        this.fetchQuote();
      }
    },
    navigateCompany() {
      const path = {
        name: "companyAdd",
        params: {
          quoteId: this.$route.params.quoteId,
          salesUid: this.$route.params.salesUid
        }
      };
      this.$router.push(path);
    },
    async deleteCompany() {
      if (confirm("Are you sure?")) {
        await nbmlaw.delete(
          `/cors/open/sales/quotes/${this.$route.params.quoteId}/company`,
          {
            params: { salesUid: this.$route.params.salesUid }
          }
        );
        this.fetchQuote();
      }
    },
    updateDebounce() {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.updateExtra();
      }, 1000);
    },
    async updateExtra() {
      this.saving = true;
      await nbmlaw.put(
        `/cors/open/sales/quotes/${this.$route.params.quoteId}/extra`,
        this.copy,
        {
          params: { salesUid: this.$route.params.salesUid }
        }
      );
      this.saving = false;
    },
    submitInstructionConfirmation() {
      this.errorIndividuals =
        this.individualsCount < 1
          ? "You must provide details for a minimum of one individual"
          : null;
      if (
        this.$refs.formInstructionConfirmation.validate() &&
        !this.errorIndividuals
      ) {
        this.createInstructionConfirmation();
      }
    },
    async createInstructionConfirmation() {
      this.submitting = true;
      this.errorSubmit = null;
      try {
        await nbmlaw.post(
          `/cors/open/sales/quotes/${this.$route.params.quoteId}/instructionConfirmation`,
          null,
          {
            params: { salesUid: this.$route.params.salesUid }
          }
        );
        this.$router.push({
          name: "thanks",
          params: {
            quoteId: this.$route.params.quoteId,
            salesUid: this.$route.params.salesUid
          }
        });
      } catch (err) {
        this.errorSubmit = "An error has occurred.  Please contact sales";
        this.submitting = false;
      }
    },
    classIndividual(individualId) {
      return `rowNormal ${individualId % 2 ? "" : "rowHighlight"}`;
    }
  },
  watch: {
    "$route.params.quoteId": {
      immediate: true,
      handler() {
        this.fetchQuote();
      }
    },
    quote: {
      handler() {
        this.individualsCount = this.quote.individuals
          ? this.quote.individuals.length
          : 0;
        if (this.quote.extra) {
          this.copy = JSON.parse(JSON.stringify(this.quote.extra));
        } else if (this.quote.quotetype.id == 1) {
          this.copy = {
            saleproperty: ""
          };
        } else if (this.quote.quotetype.id == 2) {
          this.copy = {
            purchaseproperty: ""
          };
        } else if (this.quote.quotetype.id == 3) {
          this.copy = {
            saleproperty: "",
            purchaseproperty: ""
          };
        } else if (this.quote.quotetype.id == 4) {
          this.copy = {
            transferproperty: "",
            mortgageexisting: "",
            description: ""
          };
        } else if (this.quote.quotetype.id == 5) {
          this.copy = {
            mortgageproperty: "",
            lenderexisting: "",
            lendernew: ""
          };
        }
      }
    }
  }
};
</script>

<style scoped>
.rowNormal {
  border: 1px solid #bbbbbb;
  padding: 10px;
}
.rowHighlight {
  background: #cccccc;
}
</style>